<template>
  <div class="overflow-hidden bg-gray-50 p-2 rounded border border-gray-200">
    <div class="grid grid-cols-12 gap-4 my-2">
      <div class="col-span-12">
        <iframe v-if="url" class="pdf w-full min-h-screen" :src="url"></iframe>
        <div v-else class="bg-gray-100 min-h-screen flex items-center justify-center rounded">
          <p class="text-center text-gray-500 py-5">
            Select a document to preview
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const loading = ref(false)
const url = ref<string | null>(null)

const openFile = (fileUrl: string) => {
  url.value = fileUrl
}

defineExpose({
  openFile
})
</script>

<style scoped>
.pdf {
  border: none;
}
</style>
